import React, { useState, useEffect } from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';
import { config } from '../config';

export default function ChargeLogementLayout() {
    const [nonLus, setNonLus] = useState(0);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const API_BASE = config.apiBase;

    const handleLogout = () => {
        localStorage.clear();
        toast.success('Déconnexion réussie');
        navigate('/login');
    };

    const checkNotifications = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`${API_BASE}/charge_logement/notifications.php`, {
                headers: { 'Authorization': `Bearer ${token}` }
            });
            const data = await response.json();
            if (data.success) {
                setNonLus(data.non_lus);
            }
        } catch (error) {
            console.error('Erreur:', error);
        }
    };

    useEffect(() => {
        checkNotifications();
        const interval = setInterval(checkNotifications, 30000);
        return () => clearInterval(interval);
    }, []);

    const menuItems = [
        { path: '/logements/dashboard', name: 'Dashboard', icon: '📊' },
        { path: '/logements/gestion', name: 'Gestion des chambres', icon: '🏠' },
        { path: '/tv-sahel', name: 'TV Sahel', icon: '📺' },
        { path: '/logements/feed', name: 'Fil d\'actualité', icon: '✨' },
        { path: '/logements/mes-medias', name: 'Mes médias', icon: '📱' },
        { path: '/messages-techniques', name: 'Messages', icon: '💬' },
        { path: '/logements/profil', name: 'Mon profil', icon: '👤' },
    ];

    const isActive = (path) => {
        if (path === '/logements/dashboard' && location.pathname === '/logements/dashboard') return true;
        if (path !== '/logements/dashboard' && location.pathname.startsWith(path)) return true;
        return false;
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
            {/* Sidebar Desktop */}
            <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:left-0 lg:top-0 lg:h-full lg:bg-gradient-to-b lg:from-green-800 lg:to-green-950 lg:text-white lg:shadow-xl">
                <div className="flex flex-col h-full">
                    <div className="flex-shrink-0 p-5 border-b border-green-700/50">
                        <div className="text-center">
                            <div className="w-14 h-14 bg-green-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
                                <span className="text-2xl">🏢</span>
                            </div>
                            <h2 className="text-lg font-bold">Espace Logements</h2>
                            <p className="text-xs text-green-300 mt-0.5">{user.prenom} {user.nom}</p>
                            <p className="text-xs text-green-400/70 mt-1">Chargé de logement</p>
                        </div>
                    </div>
                    
                    <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
                        {menuItems.map((item) => (
                            <Link
                                key={item.path}
                                to={item.path}
                                className={`flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm relative ${
                                    isActive(item.path)
                                        ? 'bg-green-600 text-white'
                                        : 'hover:bg-green-700/50 text-green-100'
                                }`}
                            >
                                <span className="text-lg">{item.icon}</span>
                                <span className="flex-1">{item.name}</span>
                                {item.path === '/logements/demandes' && nonLus > 0 && (
                                    <span className="absolute right-2 top-1/2 -translate-y-1/2 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white animate-pulse">
                                        {nonLus > 9 ? '9+' : nonLus}
                                    </span>
                                )}
                            </Link>
                        ))}
                    </div>
                    
                    <div className="flex-shrink-0 p-3 border-t border-green-700/50">
                        <button
                            onClick={handleLogout}
                            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-green-100 transition text-sm"
                        >
                            <span className="text-lg">🚪</span>
                            <span>Déconnexion</span>
                        </button>
                    </div>
                </div>
            </div>

            {/* Bouton menu mobile */}
            <button
                onClick={() => setMobileMenuOpen(true)}
                className="fixed top-4 left-4 z-30 lg:hidden bg-green-600 text-white p-2 rounded shadow-lg"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
                {nonLus > 0 && (
                    <span className="absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white">
                        {nonLus > 9 ? '9+' : nonLus}
                    </span>
                )}
            </button>

            {/* Sidebar mobile */}
            {mobileMenuOpen && (
                <>
                    <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setMobileMenuOpen(false)} />
                    <div className="fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-green-800 to-green-950 text-white z-50">
                        <div className="flex flex-col h-full">
                            <div className="flex-shrink-0 p-5 border-b border-green-700/50">
                                <div className="flex justify-between items-center">
                                    <div className="text-center flex-1">
                                        <div className="w-12 h-12 bg-green-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
                                            <span className="text-2xl">🏢</span>
                                        </div>
                                        <h2 className="text-lg font-bold">Espace Logements</h2>
                                        <p className="text-xs text-green-300 mt-0.5">{user.prenom} {user.nom}</p>
                                    </div>
                                    <button onClick={() => setMobileMenuOpen(false)} className="text-white/70 hover:text-white text-2xl">✕</button>
                                </div>
                            </div>
                            <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
                                {menuItems.map((item) => (
                                    <Link
                                        key={item.path}
                                        to={item.path}
                                        onClick={() => setMobileMenuOpen(false)}
                                        className={`flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm relative ${
                                            isActive(item.path)
                                                ? 'bg-green-600 text-white'
                                                : 'hover:bg-green-700/50 text-green-100'
                                        }`}
                                    >
                                        <span className="text-lg">{item.icon}</span>
                                        <span className="flex-1">{item.name}</span>
                                        {item.path === '/logements/demandes' && nonLus > 0 && (
                                            <span className="flex h-5 w-5 items-center justify-center rounded-full bg-red-500 text-xs font-bold">
                                                {nonLus > 9 ? '9+' : nonLus}
                                            </span>
                                        )}
                                    </Link>
                                ))}
                            </div>
                            <div className="flex-shrink-0 p-3 border-t border-green-700/50">
                                <button onClick={handleLogout} className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-green-100 transition text-sm">
                                    <span className="text-lg">🚪</span>
                                    <span>Déconnexion</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {/* Contenu principal */}
            <div className="lg:ml-64">
                <Outlet />
            </div>
        </div>
    );
}